import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainIdentificationSection } from './components/PainIdentificationSection';
import { NewMechanismSection } from './components/NewMechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductContentSection } from './components/ProductContentSection';
import { TransformationSection } from './components/TransformationSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { PricingSection } from './components/PricingSection';
import { EmotionalClosingSection } from './components/EmotionalClosingSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    const f = window;
    const b = document;
    const e = 'script';
    const v = 'https://connect.facebook.net/en_US/fbevents.js';
    let n: any, t: any, s: any;
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    }
    f.fbq('init', '930980669748697');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainIdentificationSection data-id="element-2" />
      <NewMechanismSection data-id="element-3" />
      <PricingSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <ProductContentSection data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <ObjectionsSection data-id="element-8" />
      <EmotionalClosingSection data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}